export const APP_CONFIG = {
  baseDomain: process.env.VUE_APP_ENDPOINT,
  mediaDomain: 'https://media.happyorder.vn',
  authSetting: {
    tokenName: 'token',
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
    configState: 'configState'
  },
  firebaseTimeFetch: 3600000,
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
};
